var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import CreatableSelect from 'react-select/creatable';
import { ThemeConsumer } from 'styled-components';
import { customStyles } from './ImgSelect';
var CreateSelect = /** @class */ (function (_super) {
    __extends(CreateSelect, _super);
    function CreateSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.create = function (theme) {
            return customStyles(theme);
        };
        _this.state = {};
        return _this;
    }
    CreateSelect.prototype.render = function () {
        var _this = this;
        return (React.createElement(ThemeConsumer, null, function (theme) {
            return React.createElement(CreatableSelect, __assign({ styles: _this.create(theme) }, _this.props));
        }));
    };
    return CreateSelect;
}(React.PureComponent));
export default CreateSelect;
//# sourceMappingURL=CreateSelect.js.map